"use strict";

require("core-js/modules/es.array.includes");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.regexp.constructor");

require("core-js/modules/es.string.includes");

require("core-js/modules/es.string.match");

var curry = require("./curry.js");

var isArray = require("./isArray.js");

var every = require("./every.js");

var entriesL = require("../Lazy/entriesL.js");

module.exports = curry(function isMatch(a, b) {
  return typeof a == 'function' ? !!a(b) : isArray(a) && isArray(b) ? every(v => b.includes(v), a) : b && typeof b == 'object' ? every(([k, v]) => b[k] == v, entriesL(a)) : a instanceof RegExp ? b.match(a) : a == b;
});